// 9fbef606107a605d69c0edbcd8029e5d
import {
  APICONFIG_ACTION_PATTERN,
  SESSIONCONFIG_ACTION_PATTERN,
} from '../../constants/reducer.constants';

export default {
  XAPP_CONFIG_MODULE: 'xappConfig',
  BOOTSTRAP_API: 'BOOTSTRAP_API',
  BOOTSTRAP_API_ERROR: 'BOOTSTRAP_API_ERROR',
  SITE_CONFIG: 'SITE_CONFIG',
  SET_API_CONFIG: `${APICONFIG_ACTION_PATTERN}SET_API_CONFIG`,
  SET_LOCATION_STATUS: `${APICONFIG_ACTION_PATTERN}SET_LOCATION_STATUS`,
  SET_DEVICE_ID: `${APICONFIG_ACTION_PATTERN}SET_DEVICE_ID`,
  SET_PREVIEW_DATE: `${APICONFIG_ACTION_PATTERN}SET_PREVIEW_DATE`,
  SET_SFCC_AUTH_TOKEN: `${APICONFIG_ACTION_PATTERN}SET_SFCC_AUTH_TOKEN`,
  GET_MODULEX_CONTENT: 'GET_MODULEX_CONTENT',
  SET_MODULEX_CONTENT: 'SET_MODULEX_CONTENT',
  LOAD_LAYOUT_DATA: 'LOAD_LAYOUT_DATA',
  LOAD_LABELS_DATA: 'LOAD_LABELS_DATA',
  SET_LABELS_DATA: 'SET_LABELS_DATA',
  LOAD_COMPONENT_LABELS_DATA: 'LOAD_COMPONENT_LABELS_DATA',
  LOAD_SEO_DATA: 'LOAD_SEO_DATA',
  SET_SEO_DATA: 'SET_SEO_DATA',
  LOAD_PAGE_SEO_DATA: 'LOAD_PAGE_SEO_DATA',
  LOAD_CATEGORY_PAGE_SEO_DATA: 'LOAD_CATEGORY_PAGE_SEO_DATA',
  SET_CATEGORY_PAGE_SEO_DATA: 'SET_CATEGORY_PAGE_SEO_DATA',
  LOAD_MODULES_DATA: 'LOAD_MODULES_DATA',
  LOAD_USER_DATA: 'GET_USER_INFO',
  SET_XAPP_CONFIG: `${SESSIONCONFIG_ACTION_PATTERN}SET_XAPP_CONFIG`,
  SET_XAPP_CONFIG_OTHER_BRAND: `${SESSIONCONFIG_ACTION_PATTERN}SET_XAPP_CONFIG_OTHER_BRAND`,
  SET_BOSS_BOPIS_FLAGS: `${SESSIONCONFIG_ACTION_PATTERN}SET_BOSS_BOPIS_FLAGS`,
  SET_COUNTRY: `${SESSIONCONFIG_ACTION_PATTERN}SET_COUNTRY`,
  SET_LANGUAGE: `${SESSIONCONFIG_ACTION_PATTERN}SET_LANGUAGE`,
  SET_CURRENCY: `${SESSIONCONFIG_ACTION_PATTERN}SET_CURRENCY`,
  COUNTRY_LIST_GET_DATA: `${SESSIONCONFIG_ACTION_PATTERN}COUNTRY_LIST_GET_DATA`,
  COUNTRY_LIST_STORE_COUNTRIES_MAP: `${SESSIONCONFIG_ACTION_PATTERN}COUNTRY_LIST_STORE_COUNTRIES_MAP`,
  COUNTRY_LIST_STORE_CURRENCIES_MAP: `${SESSIONCONFIG_ACTION_PATTERN}COUNTRY_LIST_STORE_CURRENCIES_MAP`,
  SET_SERVER_TIME: `${SESSIONCONFIG_ACTION_PATTERN}SET_SERVER_TIME`,
  GET_SERVER_TIME: `${SESSIONCONFIG_ACTION_PATTERN}GET_SERVER_TIME`,
  GET_SET_TCP_SEGMENT: `${SESSIONCONFIG_ACTION_PATTERN}GET_SET_TCP_SEGMENT`,
  SET_TCP_SEGMENT_METHOD_CALL: `${SESSIONCONFIG_ACTION_PATTERN}SET_TCP_SEGMENT_METHOD_CALL`,
  SET_DEVICE_INFO: 'SET_DEVICE_INFO',
  SET_OPTIMIZELY_FEATURES_LIST: 'SET_OPTIMIZELY_FEATURES_LIST',
  FETCH_PAGE_LAYOUT: 'FETCH_PAGE_LAYOUT',
  SET_SUB_NAVIGATION_DATA: 'SET_SUB_NAVIGATION_DATA',
  GET_SUB_NAVIGATION_DATA: 'GET_SUB_NAVIGATION_DATA',
  SET_COUNTRY_NAME: 'SET_COUNTRY_NAME',
  SET_IS_BRAND_SWITCHED: `${APICONFIG_ACTION_PATTERN}SET_IS_BRAND_SWITCHED`,
  SET_IS_BRAND_SWITCHED_APOLLO_STATEFUL_GRAPHQL: `${APICONFIG_ACTION_PATTERN}SET_IS_BRAND_SWITCHED_APOLLO_STATEFUL_GRAPHQL`,
  FETCH_LABELS: 'FETCH_LABELS',
  FETCH_GLOBAL_HEADER: 'FETCH_GLOBAL_HEADER',
  FETCH_FOOTER: 'FETCH_FOOTER',
  FETCH_LAST_UPDATED: 'FETCH_LAST_UPDATED',
  SET_LAST_UPDATED: 'SET_LAST_UPDATED',
  FETCH_SFCC_AUTH_TOKEN: 'FETCH_SFCC_AUTH_TOKEN',
  SET_CARTS_SESSION_STATUS: 'SET_CARTS_SESSION_STATUS',
  SET_NON_INVENTORY_STAGE_SESSION_FLAG: 'SET_NON_INVENTORY_STAGE_SESSION_FLAG',
  TOGGLE_SITE_MAINTENANCE_BANNER: 'TOGGLE_SITE_MAINTENANCE_BANNER',
  PROMO_SPLASH_LOADING: `${APICONFIG_ACTION_PATTERN}PROMO_SPLASH_LOADING`,
  SET_CHECKOUT_METRICS_STATUS: 'SET_CHECKOUT_METRICS_STATUS',
  LOAD_PROMO_COMBINATION_DATA: 'LOAD_PROMO_COMBINATION_DATA',
  PAGE_VISIBILITY_TITLE: 'PAGE_VISIBILITY_TITLE',
};

export const LABELS = {
  labels: 'labels',
  global: 'global',
  modules: 'modules',
  account: 'account',
  bagPage: 'bag',
  checkout: 'checkout',
};

export const PAGE_LABELS_MAPPING = {
  homepage: {
    category: ['global', 'checkout'],
    subCategory: [
      'Search',
      'header',
      'actions',
      'generic',
      'store',
      'login',
      'minibag',
      'helpCenter',
      'accountDrawer',
      'placeRewards',
      'addedToBagModal',
      'recommendations',
      'formValidation',
      'orderConfirmation',
    ],
  },
  'store-locator': {
    category: ['global', 'StoreLocator', 'checkout'],
    subCategory: [
      'Search',
      'header',
      'actions',
      'generic',
      'helpCenter',
      'minibag',
      'StoreLanding',
      'addedToBagModal',
      'orderConfirmation',
    ],
  },
  store: { category: ['global', 'checkout'], subCategory: ['orderConfirmation'] },
  sitemap: {
    category: ['global', 'checkout'],
    subCategory: [
      'Search',
      'header',
      'actions',
      'generic',
      'helpCenter',
      'store',
      'minibag',
      'orderConfirmation',
    ],
  },
  account: {
    category: ['global', 'checkout', 'account', 'FavoritesLabels', 'Browse'],
    subCategory: [
      'Search',
      'header',
      'actions',
      'generic',
      'accountDrawer',
      'placeRewards',
      'plccForm',
      'errorMessages',
      'minibag',
      'addedToBagModal',
      'bagPage',
      'orderConfirmation',
      'CommonBrowseLabels',
      'Favorites',
      'browseCommon',
      'recommendations',
    ],
  },
  plp: {
    category: ['global', 'PLP', 'Browse', 'checkout'],
    subCategory: [
      'Search',
      'header',
      'actions',
      'generic',
      'store',
      'CommonBrowseLabels',
      'Sorting',
      'errorMessages',
      'addedToBagModal',
      'minibag',
      'plpTiles',
      'seoText',
      'cartItemTile',
      'helpCenter',
      'department',
      'QuickView',
      'ProductPickup',
      'recommendations',
      'orderConfirmation',
    ],
  },
  pdp: {
    category: ['global', 'Browse', 'ProductDetailPage', 'checkout'],
    subCategory: [
      'Search',
      'header',
      'actions',
      'generic',
      'store',
      'CommonBrowseLabels',
      'addedToBagModal',
      'minibag',
      'helpCenter',
      'PDP',
      'ProductPickup',
      'emailSignup',
      'orderConfirmation',
    ],
  },
  'bundle-product': {
    category: ['global', 'CollectionsLabels', 'ProductDetailPage', 'checkout'],
    subCategory: [
      'Search',
      'header',
      'actions',
      'generic',
      'store',
      'addedToBagModal',
      'CommonBrowseLabels',
      'helpCenter',
      'minibag',
      'recommendations',
      'orderConfirmation',
    ],
  },
  search: {
    category: ['global', 'Browse', 'SLPs', 'checkout'],
    subCategory: [
      'Search',
      'header',
      'actions',
      'generic',
      'store',
      'helpCenter',
      'SLP',
      'minibag',
      'addedToBagModal',
      'QuickView',
      'ProductPickup',
      'recommendations',
      'orderConfirmation',
    ],
  },
  outfit: {
    category: ['global', 'OutfitLabels', 'Browse', 'checkout'],
    subCategory: [
      'Search',
      'header',
      'actions',
      'generic',
      'store',
      'minibag',
      'helpCenter',
      'addedToBagModal',
      'Outfit',
      'orderConfirmation',
    ],
  },
  cart: {
    category: ['global', 'checkout'],
    subCategory: [
      'Search',
      'header',
      'actions',
      'generic',
      'store',
      'login',
      'minibag',
      'helpCenter',
      'addedToBagModal',
      'bonusPoints',
      'placeCashBanner',
      'CommonBrowseLabels',
      'bagPage',
      'orderConfirmation',
    ],
  },
  content: {
    category: ['global', 'checkout'],
    subCategory: [
      'Search',
      'header',
      'actions',
      'generic',
      'store',
      'login',
      'minibag',
      'helpCenter',
      'accountDrawer',
      'placeRewards',
      'addedToBagModal',
      'orderConfirmation',
    ],
  },
  'place-card': {
    category: ['global', 'checkout'],
    subCategory: [
      'Search',
      'header',
      'actions',
      'generic',
      'store',
      'login',
      'minibag',
      'helpCenter',
      'accountDrawer',
      'placeRewards',
      'plccForm',
      'addedToBagModal',
      'orderConfirmation',
    ],
  },
  'customer-help': {
    category: ['global', 'checkout'],
    subCategory: [
      'Search',
      'header',
      'actions',
      'generic',
      'store',
      'login',
      'minibag',
      'helpCenter',
      'accountDrawer',
      'placeRewards',
      'addedToBagModal',
      'orderConfirmation',
    ],
  },
  'help-center': {
    category: ['global', 'checkout'],
    subCategory: [
      'Search',
      'header',
      'actions',
      'generic',
      'store',
      'login',
      'minibag',
      'helpCenter',
      'accountDrawer',
      'placeRewards',
      'addedToBagModal',
      'orderConfirmation',
    ],
  },
  checkout: {
    category: ['global', 'checkout'],
    subCategory: [
      'Search',
      'header',
      'actions',
      'generic',
      'store',
      'login',
      'minibag',
      'helpCenter',
      'accountDrawer',
      'placeRewards',
      'addedToBagModal',
      'smsSignup',
      'addEditAddress',
      'orderConfirmation',
    ],
  },
};

export const SEO_DATA = {
  seoData: 'seoData',
  home: '/home',
  account: '/account',
  bag: '/bag',
  checkout: '/checkout',
  search: '/search',
  storeLocator: '/storelocator',
  outfit: '/outfit',
  pdp: '/p',
  bundledPdp: '/b',
  store: '/store',
  categorySeoData: 'categorySeoData',
  storeList: '/stores',
  sitemap: '/sitemap',
  login: '/login',
  register: '/register',
};

export const MODULES_CONSTANT = {
  placeholder: 'placeholder',
  subNavigation: 'SubNavigation',
};

export const GRAPHQL_EXCEPTIONS = {
  ERROR_MESSAGES: ['UNAUTHORIZED', 'USID_UNAUTHORIZED'],
  ERROR_CODES: ['401', 'USID_UNAUTHORIZED', 'UNAUTHORIZED'],
  CHECKOUT_ERROR_MESSAGES: ['CHECKOUT_BASKET_ERROR'],
};

export const SEO_PAGE_DIRECTIVE = {
  NO_INDEX: 'NOINDEX',
  NO_FOLLOW: 'NOFOLLOW',
};
